module.exports = __webpack_public_path__ + "static/TT-Plans-Stacking_Plan-e66ff1144c1fe5832c95c7a4425bc20e.jpg";